import styled from "styled-components";

export const DivApp = styled.div`
  background: aliceblue;
  box-sizing: border-box;
  font-family: "Noto Sans JP", sans-serif;
  margin: auto;
  min-height: 100vh;
  padding-bottom: 3rem;
`;
